const mixin = {
  data () {
    return {

    }
  },
  methods: {
    keyGetValue (jsonData, currentKey) { // 由key取value
      // alert(1)
      for (var key in jsonData) {
        if (key === currentKey) return jsonData[key]
      }
    },
    valueGetKey (jsonData, currentValue) { // 由value取key
      for (var key in jsonData) {
        if (jsonData[key] === currentValue) return key
      }
    }
  }
}
export default mixin
